import { render, staticRenderFns } from "./StockContrastTable.vue?vue&type=template&id=513e5492&scoped=true&"
import script from "./StockContrastTable.vue?vue&type=script&lang=js&"
export * from "./StockContrastTable.vue?vue&type=script&lang=js&"
import style0 from "./StockContrastTable.vue?vue&type=style&index=0&id=513e5492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513e5492",
  null
  
)

export default component.exports